import { IModel, IAttribute } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { TabularCopySource } from 'app/model/pipeline/copysource/tabular-type.copysource';
import { AzureCosmosDbDataset } from 'app/model/dataset/azure-cosmos-db.dataset';


@Metamodel.model({
    name: 'DocumentDbCollectionSource',
    display: [],
    tags: { datasetModel: Metamodel.modelFor(AzureCosmosDbDataset) }
})
export class AzureCosmosCopySource extends TabularCopySource {
    public static readonly MODEL: IModel;
    public static readonly NESTING_SEPARATOR: IAttribute;

    @Metamodel.attribute({
        templatable: true,
        association: 'NESTING_SEPARATOR',
        display: stringResources.NestingSeparatorFieldLabel
    })
    public nestingSeparator?: string = '.';
}
